export default class beforeAfterImage{

    constructor() {
        this.container = document.querySelector('.image-slider-section');

        // Is the element present on the current page
        if (!this.container) {
            return;
        }
        this.imageBeforeAfter();
    }

    imageBeforeAfter() {
        // I hope this over-commenting helps. Let's do this!
        // Let's use the 'active' variable to let us know when we're using it
        var active = false;

        // First we'll have to set up our event listeners
        // We want to watch for clicks on our scroller
        document.querySelector('.scroller-img-slider').addEventListener('mousedown',function(){
            active = true;
            // Add our scrolling class so the scroller has full opacity while active
            document.querySelector('.scroller-img-slider').classList.add('scrolling-img-slider');
        });
        // We also want to watch the body for changes to the state,
        // like moving around and releasing the click
        // so let's set up our event listeners
        document.body.addEventListener('mouseup',function(){
            active = false;
            document.querySelector('.scroller-img-slider').classList.remove('scrolling-img-slider');
        });
        document.body.addEventListener('mouseleave',function(){
            active = false;
            document.querySelector('.scroller-img-slider').classList.remove('scrolling-img-slider');
        });

        // Let's figure out where their mouse is at
        /** Only for desktop */
       document.body.addEventListener('mousemove',function(e){
            if (!active) return;
            // Their mouse is here...
            let x = e.pageX;
            // but we want it relative to our wrapper
            x -= document.querySelector('.wrapper-img-slider').getBoundingClientRect().left;
            // Okay let's change our state
            scrollIt(x);
        });

       /** Only for mobile and touch devices */
        document.body.addEventListener('touchmove',function(e){
            if (!active) return;
            var i;
            for (i=0; i < e.changedTouches.length; i++) {
               let x = e.changedTouches[i].pageX;
                // but we want it relative to our wrapper
                x -= document.querySelector('.wrapper-img-slider').getBoundingClientRect().left;
                // Okay let's change our state
                scrollIt(x);
            }
        });

        // Let's use this function
        function scrollIt(x){
            let transform = Math.max(0,(Math.min(x,document.querySelector('.wrapper-img-slider').offsetWidth)));
            document.querySelector('.after-img-slider').style.width = transform+"px";
            document.querySelector('.scroller-img-slider').style.left = transform-15+"px";
        }

        mediaQ();

        /** Trigger on browser resize */
        window.addEventListener('resize', () => {
            mediaQ();
        });
        /** Trigger on mobile orientation change */
        window.addEventListener("orientationchange", () => {
            mediaQ();
        });

        function mediaQ () {
            // Let's set our opening state based off the width,
            // we want to show a bit of both images so the user can see what's going on
            const mediaQuery = window.matchMedia('(max-width: 767px)')
            if (mediaQuery.matches) {
                scrollIt(250);
            } else {
                scrollIt(550);
            }
        }


        // And finally let's repeat the process for touch events
        // first our middle scroller...
        document.querySelector('.scroller-img-slider').addEventListener('touchstart',function(){
            active = true;
            document.querySelector('.scroller-img-slider').classList.add('scrolling-img-slider');
        });
        document.body.addEventListener('touchend',function(){
            active = false;
            document.querySelector('.scroller-img-slider').classList.remove('scrolling-img-slider');
        });
        document.body.addEventListener('touchcancel',function(){
            active = false;
            document.querySelector('.scroller-img-slider').classList.remove('scrolling-img-slider');
        });
    }
}
